import React from 'react'

import styles from './HeaderLogoIcon.module.scss'

const SmallLogoIcon = () => (
  <div className={styles.smallLogoIconBlock}>
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 68 78' className='small-icon'>
      <path
        fill='#FFF'
        d='M17.7 30.9c0-.8.6-1.8 1.3-2.2l13.8-8c.7-.4 1.8-.4 2.5 0l12.1 7 17-9.8c-.1-.1-.2-.2-.4-.3l-26.9-15.9c-1.7-1-4.5-1-6.1 0l-26.9 15.9c-1.7 1-3.1 3.5-3.1 5.5v31.3l16.7-9.6v-13.9zm32.6 2.1v13.9c0 .8-.6 1.8-1.3 2.2l-13.8 8c-.7.4-1.8.4-2.5 0l-12.1-7-17 9.8c.1.1.2.2.4.3l26.9 15.8c1.7 1 4.5 1 6.1 0l27-15.8c1.7-1 3.1-3.5 3.1-5.5v-31.3l-16.8 9.6z'
      />
    </svg>
  </div>
)

const BigLogoIcon = () => (
  <div className={styles.bigLogoIconBlock}>
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 372 78' className='big-icon'>
      <path
        fill='#FFF'
        d='M106.8 26v33.8h-9.4v-33.8h-11.8v-8.1h33.1v8.1h-11.9zm18.7-8.1h9.4v41.9h-9.4v-41.9zm38.9 33.6c4.6 0 8.4-1.8 11.3-5.5l6 6.2c-4.8 5.4-10.4 8-16.8 8-6.5 0-11.8-2-16-6.1-4.2-4.1-6.3-9.2-6.3-15.4 0-6.2 2.1-11.4 6.4-15.6 4.3-4.2 9.5-6.2 15.6-6.2 6.9 0 12.6 2.6 17.3 7.9l-5.8 6.6c-3-3.7-6.6-5.5-11-5.5-3.5 0-6.5 1.1-9 3.4s-3.7 5.4-3.7 9.3c0 3.9 1.2 7 3.5 9.4 2.3 2.4 5.2 3.5 8.5 3.5zm24.7-33.6h9.4v17.2l15.8-17.2h11.6l-16.7 18.5c1.4 2 4.1 5.7 8 11.2 3.9 5.5 6.8 9.5 8.7 12.2h-10.9l-12.3-16.6-4.2 4.7v11.9h-9.4v-41.9zm80.1 15.5l-11.3 22.9h-5.6l-11.3-22.9v26.4h-9.4v-41.9h12.7l10.8 23 10.9-23h12.6v41.9h-9.4v-26.4zm19.7-15.5h9.4v41.9h-9.4v-41.9zm19.7 41.9v-41.9h9.4v33.6h17.9v8.3h-27.3zm34.1 0v-41.9h9.4v33.6h17.9v8.3h-27.3z'
      />
      <path
        fill='#FFF'
        d='M17.7 30.9c0-.8.6-1.8 1.3-2.2l13.8-8c.7-.4 1.8-.4 2.5 0l12.1 7 17-9.8c-.1-.1-.2-.2-.4-.3l-26.9-15.9c-1.7-1-4.5-1-6.1 0l-26.9 15.9c-1.7 1-3.1 3.5-3.1 5.5v31.3l16.7-9.6v-13.9zm32.6 2.1v13.9c0 .8-.6 1.8-1.3 2.2l-13.8 8c-.7.4-1.8.4-2.5 0l-12.1-7-17 9.8c.1.1.2.2.4.3l26.9 15.8c1.7 1 4.5 1 6.1 0l27-15.8c1.7-1 3.1-3.5 3.1-5.5v-31.3l-16.8 9.6z'
      />
    </svg>
  </div>
)

export const HeaderLogoIcon = (): JSX.Element => {
  return (
    <React.Fragment>
      <SmallLogoIcon />
      <BigLogoIcon />
    </React.Fragment>
  )
}
